var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeDirectoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.95,
    height: 21.95,
    viewBox: "0 0 18.95 21.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(24236 23634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M12,14v2a6,6,0,0,0-6,6H4a8,8,0,0,1,8-8Zm0-1a6,6,0,1,1,6-6A6,6,0,0,1,12,13Zm0-2A4,4,0,1,0,8,7,4,4,0,0,0,12,11Zm9.446,9.032,1.5,1.5L21.536,22.95l-1.5-1.5a4,4,0,1,1,1.414-1.414ZM18,20a2,2,0,1,0-2-2A2,2,0,0,0,18,20Z",
    transform: "translate(-24240 -23635)",
    fill: "#575757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeDirectoryIcon);
export default __webpack_public_path__ + "static/media/employee_directory_icon.f3cc35dde7133842fbbbaee5424868b7.svg";
export { ForwardRef as ReactComponent };